import React from 'react';
import styled from 'styled-components';
import { Props } from '..';

const List: React.FCC<Props> = ({
  color = 'currentColor',
  secondaryColor,
  style,
  ...rest
}) => (
  <Container {...rest}>
    <svg
      width={style?.width ?? '100%'}
      height={style?.height ?? '100%'}
      viewBox="0 0 76 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M52.8 63.5H19.2C17.9 63.5 16.8 62.4 16.8 61.1V10.8C16.8 9.49999 17.9 8.39999 19.2 8.39999H40.2L55.2 23.4V61.1C55.1 62.4 54.1 63.5 52.8 63.5Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M55.1 23.5H43C41.7 23.5 40.6 22.4 40.6 21.1V8.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.3 29.2H23.9V35.6H30.3V29.2Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.3 32.4H48.1"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.3 39.8H23.9V46.2H30.3V39.8Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.3 43H48.1"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.3 50.4H23.9V56.8H30.3V50.4Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.3 53.6H48.1"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {secondaryColor && (
        <>
          <circle cx="63.5" cy="18" r="12" fill={secondaryColor} />
          <path
            d="M63.5058 23.168C65.9698 23.168 67.7058 21.11 67.7058 18.184C67.7058 15.272 65.9698 13.214 63.5058 13.214C61.0278 13.214 59.2778 15.272 59.2778 18.184C59.2778 21.11 61.0278 23.168 63.5058 23.168ZM63.5058 21.572C62.0778 21.572 61.0698 20.172 61.0698 18.184C61.0698 16.196 62.0778 14.81 63.5058 14.81C64.9198 14.81 65.9278 16.196 65.9278 18.184C65.9278 20.172 64.9198 21.572 63.5058 21.572Z"
            fill="white"
          />
        </>
      )}
    </svg>
  </Container>
);

const Container = styled.div<{}>``;

export default List;
